import Api from './ApiService'

export default {
    get(keyword, pageNumber, sort) {
        return Api().get(`notifications/adm?keyword=${keyword}&pageNumber=${pageNumber}&sort=${sort}`);
    },
    getUsersNotifications(UserId, NotificationId, keyword, pageNumber, pageSize, order) {
        return Api().get(`notifications/users/adm?UserId=${UserId}&NotificationId=${NotificationId}&keyword=${keyword}&pageNumber=${pageNumber}&pageSize=${pageSize}&orderColumn=${order.column}&orderSort=${order.sort}`);
    },
    getTotaisUsersNotifications(NotificacaoId) {
        return Api().get(`notifications/users/totais/${NotificacaoId}`);
    },
    getOne(id) {
        return Api().get(`notifications/adm/${id}`);
    },
    create(data){
        const formData = new FormData();
        
        const jsonFields = ['buttons', 'variaveis', 'canais', 'Users', 'applicationData'];
        const skipFields = ['whatsappData', 'emailData', 'mediaUrl'];
        
        Object.keys(data).forEach(key => {
            const value = data[key];
            if (value === null || value === undefined) return;
            if (skipFields.includes(key)) return;
            
            if (jsonFields.includes(key)) {
                formData.append(key, JSON.stringify(value));
            } else if (value instanceof File) {
                formData.append(key, value);
            } else if (typeof value === 'object') {
                formData.append(key, JSON.stringify(value));
            } else {
                formData.append(key, value);
            }
        });
        
        const mediaFile = data.whatsappData?.mediaUrl;
        console.log('[NotificationService] mediaFile:', mediaFile);
        console.log('[NotificationService] mediaFile instanceof File:', mediaFile instanceof File);
        console.log('[NotificationService] mediaFile type:', typeof mediaFile);
        
        if (mediaFile) {
            if (mediaFile instanceof File || mediaFile instanceof Blob) {
                formData.append('mediaUrl', mediaFile);
                console.log('[NotificationService] Arquivo adicionado ao FormData');
            } else if (mediaFile.name && mediaFile.size && mediaFile.type) {
                formData.append('mediaUrl', mediaFile);
                console.log('[NotificationService] Arquivo (duck typing) adicionado ao FormData');
            } else {
                console.log('[NotificationService] mediaFile não é um arquivo válido:', Object.keys(mediaFile));
            }
        }
        
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        };
        return Api().post(`notifications`, formData, config);
    },
    update(data) {
        return Api().put(`notifications/${data.id}`, data);
    },
    resend_NotificationUserChannel(data) {
        return Api().post('notifications/resend_NotificationUserChannel', data);
    }
}